function isTruthyRecordId(value: unknown): boolean {
  if (value == null || value === "" || value === false) return false;
  return true;
}

/** Angular `applicationData?.is_primary` on About Yourself personal info actions. */
export function isApplicationPrimaryApplicant(applicationData: unknown): boolean {
  const record = applicationData as Record<string, unknown> | null | undefined;
  if (!record) return false;
  const v = record.is_primary;
  return v === true || v === 1 || v === "1";
}

/** Angular `applicationAllData?.resident_id` — show Resident button. */
export function hasApplicationResidentLink(applicationAllData: unknown): boolean {
  const record = applicationAllData as Record<string, unknown> | null | undefined;
  return isTruthyRecordId(record?.resident_id);
}

/** Angular `applicationAllData?.default_id` — show Default button. */
export function hasApplicationDefaultLink(applicationAllData: unknown): boolean {
  const record = applicationAllData as Record<string, unknown> | null | undefined;
  return isTruthyRecordId(record?.default_id);
}

/** Angular showResidentDefault(1) — resident list filtered by applicant id. */
export function buildAngularResidentListPathForApplicant(applicantId: string | number): string {
  const q = new URLSearchParams();
  q.set("applicant_id", String(applicantId));
  q.set("past_customer", "1");
  return `/resident?${q.toString()}`;
}

/** Angular showResidentDefault(2) — defaults list filtered by applicant id. */
export function buildAngularDefaultsListPathForApplicant(applicantId: string | number): string {
  const q = new URLSearchParams();
  q.set("applicant_id", String(applicantId));
  q.set("past_customer", "1");
  return `/defaults?${q.toString()}`;
}

/** Angular rental status line: `{status} - {progress}` when progress present. */
export function formatApplicationRentalStatusLine(
  applicationAllData: unknown,
): string | null {
  const record = applicationAllData as Record<string, unknown> | null | undefined;
  const status = record?.rental_status;
  if (status == null || String(status).trim() === "") return null;
  const progress = record?.rental_progress;
  const statusText = String(status);
  if (progress != null && String(progress).trim() !== "") {
    return `${statusText} - ${progress}`;
  }
  return statusText;
}
